/**
 * Utility to extract clean, localized error messages from Axios / ASP.NET API responses
 */
export const getApiErrorMessage = (error, defaultMessage = 'حدث خطأ ما') => {
  if (!error) return defaultMessage;

  if (typeof error === 'string') return error;

  const currentLang = localStorage.getItem('language') || 'ar';
  const isEn = currentLang === 'en';

  if (!error.response?.data) {
    if (error.message?.includes('Network Error') || error.code === 'ERR_NETWORK') {
      return isEn
        ? 'Could not connect to server, please check your internet connection.'
        : 'تعذر الاتصال بالخادم، يرجى التحقق من اتصال الإنترنت';
    }
    return error.message || defaultMessage;
  }

  const data = error.response.data;
  const status = error.response.status || data.status;

  // 1. Check for 409 Conflict (e.g., User already exists / duplicate entity)
  const isConflict =
    status === 409 ||
    (typeof data.title === 'string' && data.title.toLowerCase().includes('conflict')) ||
    (typeof data.type === 'string' && data.type.includes('15.5.10'));

  if (isConflict) {
    // If backend sent a specific detail message, prioritize it if it's not the generic RFC title
    if (typeof data.detail === 'string' && data.detail.trim() && !data.detail.toLowerCase().includes('conflicts with current data')) {
      return data.detail;
    }
    if (typeof data.message === 'string' && data.message.trim() && !data.message.toLowerCase().includes('conflicts with current data')) {
      return data.message;
    }
    return isEn
      ? 'This user or record already exists in the system.'
      : 'المستخدم أو السجل موجود بالفعل في النظام';
  }

  // 2. ASP.NET Core ValidationProblemDetails (errors dictionary)
  if (data.errors && typeof data.errors === 'object') {
    const errorList = Object.values(data.errors)
      .flat()
      .filter(Boolean);

    if (errorList.length > 0) {
      return errorList.join(' | ');
    }
  }

  // 3. Custom API error message / detail / title
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message;
  }

  if (typeof data.detail === 'string' && data.detail.trim()) {
    return data.detail;
  }

  if (typeof data.title === 'string' && data.title.trim()) {
    return data.title;
  }

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  return defaultMessage;
};
